import { useGeoMasterDataApi } from "@/features/core-shared/composables/useGeoMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useGeoCitiesMasterdataQuery() {
  const geoMasterDataApi = useGeoMasterDataApi();
  return useQuery({
    queryKey: ["geo-cities-masterdata"],
    queryFn: () => geoMasterDataApi.getCities(),
    select: ({ data }) => data,
  });
}
